import { Directive, HostListener } from '@angular/core';
import { ListingComponent } from 'src/app/_shared/components/listing/listing.component';
import { KalDialogConfig, KalDialogService } from '@kalidea/kaligraphi';
import { RgpdDialogComponent, RgpdDialogData } from 'src/app/_shared/dialogs/rgpd-dialog/rgpd-dialog.component';
import { filter, tap } from 'rxjs/operators';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

@Directive({
    selector: '[appListingConfirmRGPDDialog]',
    standalone: false
})
export class ListingConfirmRGPDDialogDirective<T> extends SubscriptionManager{


    constructor(private readonly listingComponent: ListingComponent<T>,
                private readonly dialogService: KalDialogService) {
        super();
    }

    @HostListener('export')
    openRGPDDialog(): void {
        const config = new KalDialogConfig<RgpdDialogData>({
            backdropClass: 'cdk-overlay-dark-backdrop',
            data: {
                isExport: true,
                submitButtonLabel: 'Exporter',
            }
        });

        this.watch$ = this.dialogService.open(RgpdDialogComponent, config).afterClosed.pipe(
            filter(res => res?.accepted),
            tap(() => this.listingComponent.dataSource.exportAsCSV(this.listingComponent.exportHeaders, this.listingComponent.exportName))
        );
    }
}
